/* eslint react/no-multi-comp: 0, react/prop-types: 0 */

import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

class ConfirmationModal extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			error: false,
			warning: false,
			modal: false,
			title: "",
			text: "",
			callback: function() {}
		};

		this.changeContent = this.changeContent.bind(this);
		this.show          = this.show.bind(this);
		this.hide          = this.hide.bind(this);
	}

	changeContent(title, text, error, warning, callback ) {
		this.setState({
			error: error,
			modal: true,
			warning: warning,
			title: title,
			text: text,
			callback: callback
		});
	}

	show(value) {
		this.setState({
			modal: true
		});
	}
	
	hide(value) {
		this.setState({
			modal: false
		})

		this.state.callback(value);
	}
	
	render() {
		return (
			<div>
				<Modal isOpen={this.state.modal} keyboard={false} backdrop="static" toggle={this.hide} className={this.props.className}>
					<ModalHeader>{this.state.title}</ModalHeader>
					<ModalBody>{this.state.text}</ModalBody>
					<ModalFooter>
						<Button color="secondary" onClick={() => this.hide(false)}>Revenir au formulaire</Button>{' '}
						{ !this.state.warning && !this.state.error && <Button color="primary" onClick={() => this.hide(true)}>Envoyer ces informations</Button> }
						{ this.state.warning && !this.state.error && <Button color="warning" onClick={() => this.hide(true)}>Envoyer ces informations</Button> }
					</ModalFooter>
				</Modal>
			</div>
		);
	}
}

ConfirmationModal.propTypes = {
	modalOpen: PropTypes.bool
};


export default ConfirmationModal;


// WEBPACK FOOTER //
// ./src/modals/ConfirmationModal.jsx